<template>
  <div style="min-height: 100vh; padding: 24px 32px;">

    <!-- Page Title -->
    <h2 style="font-size: 1.4rem; font-weight: 700; margin-bottom: 28px; color: #1a1a1a;">
      {{ $route.params.uuid ? "Edición de Usuarios" : "Mi cuenta" }}
    </h2>

    <!-- Card: Datos personales -->
    <v-card flat style="border-radius: 8px; margin-bottom: 28px; padding: 20px 24px;" outlined>
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;">
        <span style="font-size: 1rem; font-weight: 700;">Datos personales</span>
      </div>

      <v-row>
        <v-col cols="12" md="3">
          <v-text-field v-model="usuario.nombre" label="Nombre" outlined dense />
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field v-model="usuario.apellidoPaterno" label="Apellido Paterno" outlined dense />
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field v-model="usuario.apellidoMaterno" label="Apellido Materno" outlined dense />
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field  v-model="usuario.correo" label="Correo electrónico" outlined dense readonly
            prepend-inner-icon="mdi-email-outline"
          />
        </v-col>
      </v-row>
    </v-card>

    <!-- Card: Asignación de funciones -->
    <v-card flat style="border-radius: 8px; margin-bottom: 28px; padding: 20px 24px;" outlined>
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;">
        <span style="font-size: 1rem; font-weight: 700;">Asignación de funciones</span>
      </div>

      <v-row>
        <v-col cols="12" md="4">
          <v-select v-model="usuario.status" :items="status"  item-text="name" item-value="id" :rules="[$rules.required]" label="Estatus" outlined dense />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field disabled v-model="usuario.fechaIngreso" label="Fecha de Ingreso" outlined dense />
        </v-col>
        <v-col cols="12" md="4">
            <v-select
              v-model="usuario.rol"
              :items="rolesFiltrados"
              item-text="nombre"
              item-value="id"
              label="Rol"
              :rules="[$rules.required]"
              outlined
              dense
            />
        </v-col>
      </v-row>
      <v-row v-if="usuario.status == -1">
        <v-col cols="12" md="4">
          <v-select  v-model="usuario.motivoCancelacion" :items="motivoBajaItems" label="Motivo cancelación" outlined dense :rules="[$rules.required]"/>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field v-model="usuario.fechaBaja" label="Fecha de Baja" outlined dense />
        </v-col>
      </v-row>
    </v-card>

    <v-row class="mt-0 mb-4">
      <v-col cols="12" class="d-flex justify-end pr-6">
        <v-btn
          outlined
          color="error"
          class="mr-4"
          rounded
          @click="goBack"
        >
          Cancelar
        </v-btn>

        <v-btn
          color="error"
          rounded
          :loading="guardando"
          :disabled="guardando"
          @click="guardarTodo"
        >
          Guardar
        </v-btn>
      </v-col>
    </v-row>

    <!-- Updated data successfully Modal -->
    <v-dialog v-model="actualizadoModal" max-width="500px">
      <v-card>
        <v-card-title>{{ mensajeData }}</v-card-title>
        <v-card-actions>
          <v-btn color="primary" text
            @click="actualizadoModal = false; $router.push(`/usuario/ver-micuenta/${$route.params.uuid}`)">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import moment from "moment";
import { ListExpanded } from "~/plugins/mixins.js";

export default {
  mixins: [ListExpanded],
  name: "Usuario.Update",
  data() {
    return {
      tipo: "update",
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      roles: null,
      rolElegido: null,
      guardando: false,
      mensajeData: "",
      actualizadoModal: false,
      usuario: {
        nombre: null,
        apellidoPaterno: null,
        apellidoMaterno: null,
        rfc: null,
        curp: null,
        sexo: null,
        rol: null,
        nacimientoEstadoId: null,
        celular: null,
        telefono: null,
        status: null,
        motivoBaja: null,
        fechaBaja: null,
        fechaIngreso: null,
        ramo: null,
        canal: null,
        landing: null,
        vip: false,
        codigoValidador: null,
        motivoCancelacion: null,
        motivosOpciones: [],
      },
      usuarioAgente: {
        fuenteIngreso: null,
        regimen: null,
        asociadoPromotoria: null,
        tipoAgente: null,
        razonSocial: null,
        clabeBancaria: null,
        claveAgente: null,
        tipoCedula: null,
        nivelAgente: null,
        numeroCartera: null,
        cedula: null,
        rc: null,
        vigenciaCedula: null,
        vigenciaPolizaRC: null,
      },
      checkbox: false,
      canalList: [],
      ramoList: [],
      campaniaList: [],
    };
  },

  created() {},

  mounted() {
    this.getRoles();
    this.getUser();
  },

  computed: {
    rolesFiltrados() {
      //ADMIN PUEDE HACER LO QUE SEA TRAE PODER DIVINO EL AMIGO
      if (!this.roles) return [];
      if (this.rol == "ADMIN") return this.roles;

      //permisos segun la tabla DE Excel
      const rolePermissions = {
        ADMINCUENTA: [
          "OPERADORSERVICIOS",
          "AGENTCC",
          "SUPERVISOR",
          "COORDINADOR",
          "GERENTE",
          "BACKOFFICE",
          "AGENTCCELITE"
        ],
        COORDINADOR: ["OPERADORSERVICIOS", "AGENTCC", "AGENTCCELITE", "SUPERVISOR"],
        GERENTE: ["OPERADORSERVICIOS", "AGENTCC", "SUPERVISOR", "AGENTCCELITE", "COORDINADOR"],
        SUPERVISOR: ["OPERADORSERVICIOS", "AGENTCC", "AGENTCCELITE"],
      };

      //traemos lOS PERMISOS SEGUN EL ROL QUE SE TENGA EN SESSION
      const allowedRoles = new Set(rolePermissions[this.rol] || []);

      //FILTRAMOS Y VUALAAA😁!!!
      return this.roles.filter((r) => allowedRoles.has(r.id));
    },
  },
  methods: {
    getUser() {
      let uuid = this.$route.params.uuid;
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      if (this.$route.params.uuid) {
        this.tipo = "update";
        this.$axios.get(`/v1/agente/uuid/${uuid}`, config).then((response) => {

          let rolesBase =
            response.data.roles.length > 0 ? response.data.roles : [];
          let roles = [];
          rolesBase.forEach((element) => {
            if (element.rol != null) {
              roles.push(element.rol);
            }
          });

          console.log(response.data, "data del usuario");

          if (roles.length > 0) {
            this.usuario.rol = roles[0];
          } else {
            this.usuario.rol = "";
          }

          this.usuario.correo = response.data.username;
          this.usuario.nombre = response.data.nombre;
          this.usuario.apellidoPaterno = response.data.apellidoPaterno;
          this.usuario.apellidoMaterno = response.data.apellidoMaterno;
          this.usuario.celular = response.data.celular;
          this.usuario.telefono = response.data.telefono;
          this.usuario.fechaNacimiento = moment(
            response.data.fechaNacimiento,
            "YYYY-MM-DD"
          ).format("DD/MM/YYYY");
          this.usuario.fechaRegistro = moment
            .utc(response.data.fechaRegistro)
            .subtract(6, "hours")
            .format("DD/MM/YYYY HH:mm");
          this.usuario.sexo = response.data.sexo;
          this.usuario.nacimientoEstadoId = response.data.nacimientoEstadoId;
          this.usuario.rfc = response.data.rfc;
          // this.usuario.curp = response.data.curp
          this.usuario.status = response.data.status;
          this.usuario.socioId = response.data.socioId;
          this.usuario.ramo = response.data.ramos;
          this.usuario.canal = response.data.canales;
          this.usuario.landing = response.data.landings;
          this.usuario.fechaIngreso = response.data.fechaRegistro ? moment(response.data.fechaRegistro, "YYYY-MM-DD HH:mm:ss").format("YYYY/MM/DD") : null;

          // let from = moment(response.data.fechaBaja, "DD/MM/YYYY");
          // this.usuario.fechaBaja = from.add(1, 'days');

          this.usuario.motivoCancelacion = response.data.motivoBaja;
          this.usuario.motivosOpciones = [this.usuario.motivoCancelacion];
          this.usuario.fechaBaja = response.data.fechaBaja
            ? moment(response.data.fechaBaja).add(1, "days").format("DD/MM/YYYY")
            : null;

          this.usuario.creadoPor = response.data.creadoPor
            ? response.data.creadoPor
            : null;
          this.usuario.fechaCreacion = response.data.fechaRegistro
            ? moment
                .utc(response.data.fechaRegistro)
                .subtract(6, "hours")
                .format("DD/MM/YYYY HH:mm:ss")
            : null;
          this.usuario.codigoValidador = response.data.codigoValidador;

          // this.creadoPor = response.data.creadoPor ? response.data.creadoPor : null
          // this.fechaCreacion = response.data.fechaRegistro ? moment.utc(response.data.fechaRegistro).subtract(6, 'hours').format('DD/MM/YYYY HH:mm:ss') : null
          // this.modificadoPor = response.data.modificadoPor ? response.data.modificadoPor : null
          // this.fechaModificacion = response.data.ultimaModificacion ? moment.utc(response.data.ultimaModificacion).subtract(6, 'hours').format('DD/MM/YYYY HH:mm:ss') : null

          // this.usuarioAgente.fuenteIngreso = response.data.fuenteIngreso ? response.data.fuenteIngreso : null
          // this.usuarioAgente.regimen = response.data.regimen ? response.data.regimen : null
          // this.usuarioAgente.asociadoPromotoria = response.data.agenteAsociadoPromotoria ? response.data.agenteAsociadoPromotoria : null
          // this.usuarioAgente.tipoAgente = response.data.tipoAgente ? response.data.tipoAgente : null
          // this.usuarioAgente.razonSocial = response.data.razonSocial ? response.data.razonSocial : null
          // this.usuarioAgente.clabeBancaria = response.data.clabeBancaria ? response.data.clabeBancaria : null
          // this.usuarioAgente.claveAgente = response.data.claveAgente ? response.data.claveAgente : null
          // this.usuarioAgente.tipoCedula = response.data.tipoCedula ? response.data.tipoCedula : null
          // this.usuarioAgente.nivelAgente = response.data.nivelAgente ? response.data.nivelAgente : null
          // this.usuarioAgente.numeroCartera = response.data.numeroCartera ? response.data.numeroCartera : null
          // this.usuarioAgente.cedula = response.data.cedula ? response.data.cedula : null
          // this.usuarioAgente.rc = response.data.rc ? response.data.rc : null
          // this.usuarioAgente.vigenciaCedula = response.data.vigenciaCedula ? moment(response.data.vigenciaCedula, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
          // this.usuarioAgente.vigenciaPolizaRC = response.data.vigenciaPolizaRc ? moment(response.data.vigenciaPolizaRc, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
        });
      } else {
        this.tipo = "updateCuenta";
        this.$axios
          .get(`/v1/agente/uuid/${localStorage.agenteUuid}`, config)
          .then((response) => {
            let rolBase =
              response.data.roles.length == 0
                ? "AGENT"
                : response.data.roles[0].rol;
            this.usuario.nombre = response.data.nombre;
            this.usuario.apellidoPaterno = response.data.apellidoPaterno;
            this.usuario.apellidoMaterno = response.data.apellidoMaterno;
            this.usuario.correo = response.data.username;
            this.usuario.celular = response.data.celular;
            this.usuario.telefono = response.data.telefono;
            this.usuario.fechaNacimiento = moment(
              response.data.fechaNacimiento,
              "YYYY-MM-DD"
            ).format("DD/MM/YYYY");
            this.usuario.fechaRegistro = moment
              .utc(response.data.fechaRegistro)
              .subtract(6, "hours")
              .format("DD/MM/YYYY HH:mm");
            this.usuario.sexo = response.data.sexo;
            this.usuario.nacimientoEstadoId = response.data.nacimientoEstadoId;
            this.usuario.rfc = response.data.rfc;
            // this.usuario.curp = response.data.curp
            this.usuario.status = response.data.status;
            this.usuario.rol = rolBase;
            this.usuario.ramo = response.data.ramos;
            this.usuario.canal = response.data.canales;
            this.usuario.landing = response.data.landings;
            this.usuario.socioId = response.data.socioId;
            this.usuario.codigoValidador = response.data.codigoValidador;

            // this.usuarioAgente.fuenteIngreso = response.data.fuenteIngreso ? response.data.fuenteIngreso : null
            // this.usuarioAgente.regimen = response.data.regimen ? response.data.regimen : null
            // this.usuarioAgente.asociadoPromotoria = response.data.agenteAsociadoPromotoria ? response.data.agenteAsociadoPromotoria : null
            // this.usuarioAgente.tipoAgente = response.data.tipoAgente ? response.data.tipoAgente : null
            // this.usuarioAgente.razonSocial = response.data.razonSocial ? response.data.razonSocial : null
            // this.usuarioAgente.clabeBancaria = response.data.clabeBancaria ? response.data.clabeBancaria : null
            // this.usuarioAgente.claveAgente = response.data.claveAgente ? response.data.claveAgente : null
            // this.usuarioAgente.tipoCedula = response.data.tipoCedula ? response.data.tipoCedula : null
            // this.usuarioAgente.nivelAgente = response.data.nivelAgente ? response.data.nivelAgente : null
            // this.usuarioAgente.numeroCartera = response.data.numeroCartera ? response.data.numeroCartera : null
            // this.usuarioAgente.cedula = response.data.cedula ? response.data.cedula : null
            // this.usuarioAgente.rc = response.data.rc ? response.data.rc : null
            // this.usuarioAgente.vigenciaCedula = response.data.vigenciaCedula ? moment(response.data.vigenciaCedula, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
            // this.usuarioAgente.vigenciaPolizaRC = response.data.vigenciaPolizaRc ? moment(response.data.vigenciaPolizaRc, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
          });
      }
    },
    setData() {

      this.guardando = true;
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      let dataAgent = {
        nombre: this.usuario.nombre,
        apellidoPaterno: this.usuario.apellidoPaterno,
        apellidoMaterno: this.usuario.apellidoMaterno,
        sexo: this.usuario.sexo,
        fechaNacimiento: moment(
          this.usuario.fechaNacimiento,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD"),
        nacimientoEstadoId: this.usuario.nacimientoEstadoId,
        telefono: this.usuario.telefono,
        celular: this.usuario.celular,
        correo: this.usuario.correo,
        rfc: this.usuario.rfc,
        // curp: this.usuario.curp,
        rol: this.usuario.rol,
        status: this.usuario.status,
        motivoBaja: this.usuario.status == -1 ? this.usuario.motivoCancelacion : null,
        fechaBaja:
          this.usuario.status == -1
            ? moment(this.usuario.fechaBaja, "DD/MM/YYYY").format("YYYY-MM-DD")
            : null,
        ramos: this.usuario.ramo,
        socioId: this.usuario.socioId ? this.usuario.socioId : null,
        canales: this.usuario.canal,
        landings: this.usuario.landing ? this.usuario.landing : null,
        // fechaRegistro: this.usuario.fechaRegistro,
        // creadoPor: this.creadoPor ? this.creadoPor : null,

        modificadoPor: this.usuario.modificadoPor,
        ultimaModificacion: this.fechaModificacion,
        codigoValidador: this.usuario.codigoValidador,

        // fuenteIngreso: this.usuarioAgente.fuenteIngreso ? this.usuarioAgente.fuenteIngreso : null,
        // regimen: this.usuarioAgente.regimen ? this.usuarioAgente.regimen : null,
        // agenteAsociadoPromotoria: this.usuarioAgente.asociadoPromotoria ? this.usuarioAgente.asociadoPromotoria : null,
        // tipoAgente: this.usuarioAgente.tipoAgente ? this.usuarioAgente.tipoAgente : null,
        // razonSocial: this.usuarioAgente.razonSocial ? this.usuarioAgente.razonSocial : null,
        // clabeBancaria: this.usuarioAgente.clabeBancaria ? this.usuarioAgente.clabeBancaria : null,
        // claveAgente: this.usuarioAgente.claveAgente ? this.usuarioAgente.claveAgente : null,
        // tipoCedula: this.usuarioAgente.tipoCedula ? this.usuarioAgente.tipoCedula : null,
        // nivelAgente: this.usuarioAgente.nivelAgente ? this.usuarioAgente.nivelAgente : null,
        // numeroCartera: this.usuarioAgente.numeroCartera ? this.usuarioAgente.numeroCartera : null,
        // cedula: this.usuarioAgente.cedula ? this.usuarioAgente.cedula : null,
        // rc: this.usuarioAgente.rc ? this.usuarioAgente.rc : null,
        // vigenciaCedula: this.usuarioAgente.vigenciaCedula ? moment(this.usuarioAgente.vigenciaCedula, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
        // vigenciaPolizaRc: this.usuarioAgente.vigenciaPolizaRC ? moment(this.usuarioAgente.vigenciaPolizaRC, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
      };
      if (this.$route.params.uuid) {
        this.$axios
          .put(
            `/v1/agente/update/${this.$route.params.uuid}`,
            dataAgent,
            config
          )
          .then((value) => {
            this.guardando = false;
            this.mensajeData =
              value.data.status == "FAILED"
                ? "Error al actualizar los datos"
                : "Actualización de datos correcta";
            value.status == 200 ? (this.actualizadoModal = true) : "";
          });
      } else {
        this.$axios
          .put(
            `/v1/agente/update/${localStorage.agenteUuid}`,
            dataAgent,
            config
          )
          .then((value) => {
            this.guardando = false;
            value.status == 200 ? (this.actualizadoModal = true) : "";
          });
      }
    },
    getRoles() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };

      this.$axios.get("/v1/agente/roles/list", config).then(({ data }) => {
        this.roles = data.map((e) => ({
          id: e.rol,
          nombre: e.nombre,
        }));
      });
    },

    validateEmailDomain(value) {
        if (!value) return "El correo es requerido";

        const allowedDomains = ["segurosyasisteneciasbc.com.mx", "gabssa.mx", "inter.mx"];

        const domain = value.split("@")[1];

        if (!domain) return "Correo inválido";

        if (!allowedDomains.includes(domain)) {
          return `Los dominios validos son ${allowedDomains.join(" o ")}`;
        }

        return true;
      },
      goBack() {
        if (this.$route.params.uuid) {
          this.$router.push(`/usuario/ver-micuenta/${this.$route.params.uuid}`);
        } else {
          this.$router.push("/usuario/ver-micuenta");
        }
      },
      guardarTodo() {
        this.setData();
      },
    }
  };
</script>
<style scoped></style>
